import EventBus from "./event-bus";
import {errorHandler} from "./common";

const axios = require('axios');

export function userSignIn(email, password) {
  return new Promise(function (resolve, reject) {
    let url = process.env.ROOT_API + 'user/signIn?email=' + email + '&password=' + password;
    axios.post(url)
      .then(function (response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function (error) {
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        reject(error);
      })
  })
}

export function addUser(user) {
  return new Promise(function (resolve, reject) {
    axios.post(process.env.ROOT_API + 'user/signUp', JSON.stringify(user), {
      headers:{
        "Content-Type": "application/json",
        // "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function (response) {
        let data = response['data'];
        console.log("Add USER");
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        reject(error)
      });
  })
}

export function getUserByToken() {
  return new Promise(function(resolve, reject) {
    // console.log("getUserBytToken " + localStorage.getItem("JSTOKEN") + " "  + process.env.ROOT_API);
    axios.get(process.env.ROOT_API + 'user/me', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response['data'];
      // console.log(data);
      if(data != null && data != "") {
        resolve(data);
      } else {
        EventBus.$emit("sessionExpired");
        // reject();
      }
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}


export function getUserList(type) {
  return new Promise(function(resolve, reject) {
    console.log("get user list type " + type);
    axios.get(process.env.ROOT_API + 'admin/users/type?type='+type, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
    .catch(error=>{
      console.log("error to update");
      console.log(error.response);
      errorHandler(error);
      reject(error)
    });
  })
}

export function getDriverList() {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/users/drivers', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response['data'];
      // console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        //reject()
        errorHandler(error);
        reject(error)
      });
  })
}
/**
 * Create users at one go
 * @param user
 * @returns {Promise<unknown>}
 */
export function createUsers(users) {
  return new Promise(function (resolve, reject) {
    axios.post(process.env.ROOT_API + 'users', JSON.stringify(users), {
      headers:{
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function (response) {
        let data = response['data'];
        console.log("Update USER");
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getUser(id) {
  return new Promise(function (resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/user?userId=' + id, {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function (response) {
        let data = response['data'];
        console.log("Update USER");
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
/**
 * Create users at one go
 * @param user
 * @returns {Promise<unknown>}
 */
export function updateUser(user) {
  return new Promise(function (resolve, reject) {
    axios.post(process.env.ROOT_API + 'admin/user', JSON.stringify(user), {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function (response) {
        let data = response['data'];
        console.log("Update USER");
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function resetUser(user) {
  return new Promise(function (resolve, reject) {
    axios.post(process.env.ROOT_API + 'user', JSON.stringify(user), {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function (response) {
        let data = response['data'];
        console.log("Update USER");
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function deleteUser(id) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.delete(process.env.ROOT_API + 'admin/user/delete?id='+id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function (response) {
        EventBus.$emit("showLoading", false);
        let data = response['data'];
        console.log("Update USER");
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getMerchantUserList(merchantId) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/merchant/users?merchantId=' + merchantId, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function sendEmail(content) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.ROOT_API + 'sendEmail', JSON.stringify(content), {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function (response) {
        let data = response['data'];
        console.log("Update USER");
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function createNewUser() {
  let newUser = {
    id:0,
    name:'',
    email:'',
    password:'',
    password2:'',
    merchantId:0,
    role:'staff',
    type:'ROLE_STAFF',
    wmsManage:false,
    wmsPick:false,
    wmsPickCheck:false,
    wmsPickConfirm:false,
    superUser:false,
    orderAccessLevel:0,
    accessOrderLevel:0,
    productAccessLevel:0,
    merchantAccessLevel:0,
    vendorAccessLevel:0,
    vendorOrderAccessLevel:0,
    settingAccessLevel:0,
    creditAccessLevel:0,
    reportAccessLevel:0,
    notificationAccessLevel:0,
    defaultShift:0,
    canChangeAccess: false,
  }

  return newUser;
}



// WEBPACK FOOTER //
// ./src/api/user.js